import { useState } from "react";
import { useScrollFadeIn } from "@/hooks/useScrollFadeIn";

const playItems = [
  "フェチ",
  "ペニバン",
  "変態的要素のあるプレイ全般",
  "スパンキング（ディシプリンを含む）",
  "フェザータッチ",
  "精神的な支配",
  "ハンドジョブ / ルーインドコントロール",
  "その他、性癖を用いたコミュニケーション",
];

const extraPlayItems = [
  "アナルプレイ",
  "顔面騎乗",
  "乳首責め",
  "手コキ",
  "射精管理",
  "亀頭責め",
  "ローションストッキング",
  "潮吹き",
  "唾液責め",
  "くすぐり",
  "ストーリープレイ",
  "M格闘",
];

const ngItems = [
  "本番行為",
  "フェラチオ",
  "トップレス",
  "嘔吐・過度な飲酒を伴う行為",
];

export default function SessionSection() {
  const [expanded, setExpanded] = useState(false);
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>();
  const { ref: card1Ref, style: card1Style } = useScrollFadeIn<HTMLDivElement>({ delay: 0.05 });
  const { ref: card2Ref, style: card2Style } = useScrollFadeIn<HTMLDivElement>({ delay: 0.05 });

  return (
    <section id="session" className="py-10 md:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div ref={headRef} style={headStyle} className="text-center mb-8 md:mb-16">
          <h2
            className="font-en text-2xl md:text-4xl font-light text-stone-800 tracking-widest"
          >
            Session Contents
          </h2>
          <div className="w-8 h-px bg-amber-400 mx-auto mt-3 md:mt-5"></div>
        </div>

        {/* セッション内容 */}
        <div ref={card1Ref} style={card1Style} className="bg-stone-50 p-8 md:p-10 border border-stone-200 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-heart-line text-amber-600 text-lg"></i>
            </div>
            <h3 className="text-base tracking-[0.2em] text-stone-700 font-medium">セッション内容</h3>
          </div>

          {/* Desktop: 2列グリッド / Mobile: タグ形式 */}
          <ul className="hidden sm:grid grid-cols-2 gap-x-6 gap-y-3">
            {playItems.map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-base text-stone-600">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 flex-shrink-0"></span>
                {item}
              </li>
            ))}
          </ul>
          <ul className="sm:hidden flex flex-wrap gap-2">
            {playItems.map((item, i) => (
              <li key={i} className="px-3 py-1.5 bg-amber-50/80 border border-amber-300/60 text-sm text-stone-700 tracking-wide">
                {item}
              </li>
            ))}
          </ul>

          {/* 追加コンテンツ */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              expanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="border-t border-stone-200 mt-5 pt-5">
              {/* Desktop: 2列グリッド / Mobile: タグ形式 */}
              <ul className="hidden sm:grid grid-cols-2 gap-x-6 gap-y-3">
                {extraPlayItems.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-base text-stone-600">
                    <span className="w-1.5 h-1.5 rounded-full bg-amber-300 mt-2 flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
              <ul className="sm:hidden flex flex-wrap gap-2">
                {extraPlayItems.map((item, i) => (
                  <li key={i} className="px-3 py-1.5 bg-amber-50/50 border border-amber-200/50 text-sm text-stone-500 tracking-wide">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* トグルボタン */}
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-6 flex items-center gap-2 text-base text-amber-700 hover:text-amber-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>{expanded ? "閉じる" : "さらに見る"}</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i
                className={`ri-arrow-down-s-line text-base transition-transform duration-300 ${
                  expanded ? "rotate-180" : ""
                }`}
              ></i>
            </div>
          </button>
        </div>

        {/* NG行為 — 控えめに */}
        <div ref={card2Ref} style={card2Style} className="px-6 py-5 border border-stone-100 bg-white">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-close-circle-line text-stone-300 text-base"></i>
            </div>
            <h3 className="text-xs tracking-[0.25em] text-stone-400 font-medium uppercase">NG行為</h3>
          </div>
          <ul className="flex flex-wrap gap-2">
            {ngItems.map((item, i) => (
              <li key={i} className="px-3 py-1.5 bg-white border border-stone-200/80 text-sm text-stone-400 tracking-wide">
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-4 text-sm text-stone-300 leading-relaxed">
            上記以外でも、相応しくないと判断した場合はお断りする場合がございます。
          </p>
        </div>
      </div>
    </section>
  );
}
